export default __webpack_public_path__ + "static/media/bg2.c4995493.png";